/**
 * Canonical stage lists for Intuiterview's async operations.
 *
 * IMPORTANT: Every stage listed here corresponds to REAL backend work.
 * The backend pipeline (`_analyze_pipeline_bg`, `_align_pipeline_bg`,
 * `_rescore_aligned_bg`) writes the matching `stage` value onto the
 * job document at each natural checkpoint. Do NOT add stages that
 * aren't backed by an actual server-side transition - that would be
 * fake progress, exactly what we're trying to avoid.
 */

// POST /resume/analyze → GET /resume/analyses/{id}.stage
// Backend transitions: queued → reading_resume → matching_requirements → scoring → ready
export const ANALYZE_STAGES = [
  { key: "queued",                 label: "Queuing your analysis" },
  { key: "reading_resume",         label: "Reading your resume and career context" },
  { key: "matching_requirements",  label: "Matching your experience to the role" },
  { key: "scoring",                label: "Calculating alignment and ATS scores" },
  { key: "ready",                  label: "Preparing your results" },
];

// POST /resume/align → GET /resume/aligned/{id}.stage
// Backend transitions: queued → loading_context → rewriting_resume → rescoring → ready
export const ALIGN_STAGES = [
  { key: "queued",           label: "Queuing your rewrite" },
  { key: "loading_context",  label: "Loading your resume and target role" },
  { key: "rewriting_resume", label: "Rewriting your resume for this role" },
  { key: "rescoring",        label: "Recalculating your alignment score" },
  { key: "ready",            label: "Preparing your results" },
];

// POST /resume/export-docx (fast, synchronous - stages are client-side
// only, timed loosely with the request lifecycle). These are HONEST
// because the download flow really does go through: formatting →
// (optional PDF conversion) → returning bytes.
export const RESUME_DOWNLOAD_STAGES_DOCX = [
  { key: "formatting", label: "Formatting your content" },
  { key: "template",   label: "Applying the executive template" },
  { key: "finalizing", label: "Finalizing your document" },
];

export const RESUME_DOWNLOAD_STAGES_PDF = [
  { key: "formatting", label: "Formatting your content" },
  { key: "template",   label: "Applying the executive template" },
  { key: "pdf",        label: "Generating PDF" },
  { key: "finalizing", label: "Finalizing your download" },
];
